export default "__VITE_ASSET__BqP1zQ3k__"